import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Header from "../InitialPage/Sidebar/Header";
import Sidebar from "../InitialPage/Sidebar/Sidebar";
import { authRoute, publicRoutes } from "./router.link";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToasterContainer } from "../feature-module/components/toaster/Toaster";
import { all_routes } from "./all_routes";
import { createTheme, ThemeProvider } from "@mui/material";

const AllRoutes = () => {

  const routes = all_routes;

  let theme = createTheme();
  theme = createTheme({
    palette: {
      primary: {
        main: "#1E5C7D",
        contrastText: "#fff",
      },
      secondary: {
        main: "#092C4C",
        contrastText: "#fff",
      },
    },
    typography: {
      fontFamily: "Nunito, sans-serif",
    },
  });

  const { toggleHeader, userData } = useSelector((state) => {
    return {
      toggleHeader: state.toggle_header,
      userData: state.user_data
    }
  });

  const HeaderLayout = () => (
    <div className={`main-wrapper ${toggleHeader ? "header-collapse" : ""}`}>
      {/* <Loader /> */}
      <Header />
      <Sidebar />
      <Outlet />
    </div>
  );

  const Authpages = () => (
    <div>
      <Outlet />
      {/* <Loader /> */}
    </div>
  );

  return (
    <ThemeProvider theme={theme}>

      {/* ========== Toaster ========== */}
      <ToasterContainer />

      <Routes>
        <Route path={"/"} element={userData?.token ? <HeaderLayout /> : <Navigate to={routes?.signin} />}>
          {publicRoutes.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>

        <Route path={"/"} element={userData?.token ? <Navigate to={routes?.dashboard} /> : <Authpages />}>
          {authRoute.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>
      </Routes>
    </ThemeProvider>
  );
};
export default AllRoutes;
